













































































































































































































































import {Component, Prop} from 'vue-property-decorator';
import Form, { Send } from '@/components/form-base';
import { DialogForm, FormOverlay, CardForm } from '@/components/bwaff';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';
import _ from 'lodash';
import DialogFormTitleButtons from '@/components/dialogs/dialog-form-title-buttons.vue';
import userManagerApi,{impersonateMember, UserManagerApi} from '@/views/settings/multi-user-access/user-manager/api';
import workspacesApi, {WorkspacesApi} from '@/views/settings/multi-user-access/workspaces/api';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
const md5 = require('md5');


  @Component({
    components: {
      FormOverlay,
      DialogForm,
      CardForm,
      ErrorAggregator,
      DialogFormTitleButtons,
    }
  })
  export default class CreateMemberDialog extends  mixins(PlanLimitsMixin,Form) {
    @Prop({ default: {} })
    data: any;

    userManagerApi: UserManagerApi = userManagerApi;
    workspacesApi: WorkspacesApi = workspacesApi;

    show: boolean = false;
    loading: boolean = false;
    isResetTwoFactorAvailable: boolean = false;

    form: any = this.getDefaultForm();
    user: any = null;

    isAddWorkspaceMenuOpened:boolean = false;
    addWorkspaceMenuSelected: any = [];

    rows: any = [];

    allPrivateWorkspaces: any = [];
    allPrivateWorkspacesNormalized: any = {};
    workspacesSearch: string = '';
     
    errors: any[] = [];
    errorsControlActive: boolean = false;

    oldHash: string = '';
    getCurrentHash() {
      return md5(JSON.stringify(this.form));
    }

    get helpText() {
      if(this.form.role === 'admin') return this.t('Admin has full access to Public and all private workspaces assigned to him.')

      if(this.form.id){
        return this.t('User has the access to Public workspace and private workspaces assigned to him.<br> The access to the separate elements should be managed through Permissions setting.')
      }else{
        return this.t('Users receive the Full access to all the elements by default.<br> It is possible to change the access type in Permissions settings below.')
      }
    }

    get tableRows() {
      if (!this.rows) return [];
      return this.form.workspaces.map((row: any) => {
        return {
          name: row.name,
          actions: '',
          id: row.id,
        }
      });
    }

    statusText(status:string) {
      switch(status) {
        case 'active':
          return this.t('Active');
        case 'blocked':
          return this.t('Blocked');
        default:
          return '';
      }
    }
    
    get defaultRole(){
      if(!this.hasPlanLimitsRestriction('memberAdminsAmount')){return 'admin'}
      if(!this.hasPlanLimitsRestriction('memberUsersAmount')){return 'user'}
      return ''
    }

    getDefaultForm() {
      return {
        login: '',
        role: this.defaultRole,
        fullName: '',
        lastName: '',
        status: 'active',
        twoFactorEnabled: false,
        twoFactorDisableCheck:false,
        accessCustomConversions: false,
        workspaces:[] as Array<any>
      };
    }

    open(user: any) {
      this.loading = false;

      if (user && user.id) {
        this.user = user;
        const formValues = _.pick(user,
          [
            'login',
            'password',
            'fullName',
            'role',
            'id',
            'status',
            'twoFactorEnabled',
            'twoFactorDisableCheck',
            'accessCustomConversions',
            'workspaces'
          ]);

        formValues.fullName = `${user.firstName || ''} ${user.lastName || ''}`.trim();
        formValues.twoFactorDisableCheck = false;
        formValues.accessCustomConversions = !!user.accessCustomConversions;
        formValues.workspaces = formValues.workspaces || [];

        this.form = formValues;
        this.isResetTwoFactorAvailable = formValues.twoFactorEnabled

        this.show = true;
        this.$store.commit('loading', false);
      } else {
        this.form = this.getDefaultForm();

        this.user = null;
        this.show = true;
      }

      this.oldHash = this.getCurrentHash()

      this.allPrivateWorkspaces = [...this.workspacesApi.dataPrivate];
      this.allPrivateWorkspacesNormalized = {...this.workspacesApi.dataPrivateNormalized};
    }

    get searchedWorkspaces() {
      return this.workspacesSearch.trim()
        ? this.allPrivateWorkspaces.filter((workspace:any)=>{
          return workspace.name && workspace.name.toLowerCase().includes(this.workspacesSearch.toLowerCase())
        })
        : this.allPrivateWorkspaces
    }

    get headers() {
      return [
        {
          text: this.t('Name'),
          value: 'name',
          sortable: false
        },
        {
          value: 'actions',
          sortable: false
        },
      ]
    }

    createMember(data:object) {
      return this.userManagerApi.post(data).then(() => {
        this.userManagerApi.getMembers().then(() => {
          this.close();
          this.bus.emit('toast-success', this.t('User successfully added.'));
        });
      })
    }

    updateMember(data:object) {
      return this.userManagerApi.put(this.form.id, data).then(async () => {
        return await this.userManagerApi.getMembers().then(() => {
          this.close()
          this.bus.emit('toast-success', this.t('User successfully changed.'));
        });
      });
    }

    @Send(true)
    save() {
      this.loading = true;

      let form: any = {
        ...this.form,
      };

      form.workspaceIds = form.workspaces.map((workspace:any)=>workspace.id);

      form = _.omit(form,['workspaces']);

      // don't send twoFactorDisableCheck if false
      if(!this.form.twoFactorDisableCheck){
        form = _.omit(form,['twoFactorDisableCheck']);
      }

      let promise = this.form.id
        ? this.updateMember(form)
        : this.createMember(form);

      this.$store.commit('loading', true);

      return promise.then(()=>{
        return this.workspacesApi.getWorkspaces();
      })
        .catch((error) => {
          this.loading = false;
          return Promise.reject(error);
        })
        .finally(() => {
          this.$store.commit('loading', false);
          this.userManagerApi.loading = false;
        });
    }

    saveWorkspaceMenu() {
      this.form.workspaces = this.addWorkspaceMenuSelected;
      this.toggleAddWorkspacesMenu();
    }

    checkClose() {
      if (this.oldHash !== this.getCurrentHash()) {
        this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
          onConfirm: () => this.close(),
        }})
      } else {
        this.close();
      }
    }

    close() {
      this.$emit('close');
    }

    resetPasswordConfirmCall() {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
        message: this.t('The password will be reset if you press OK.'),
        onConfirm: () => {
          this.userManagerApi.postResetPassword(this.form.id)
            .then(()=>this.bus.emit('toast-success', this.t('Password successfully reset.')))
        },
      }})
    }

    showConfirmImpersonate() {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
        message: this.t('When logging in as another user or admin, you will be provided with the read-only access to settings of this member.<br> No editing in the member’s account allowed.<br> You can go back to your account by clicking <b>Return back</b> at the top of the page.'),
        confirmButtonText: this.t('Log In As Member'),
        confirmButtonIcon: 'fas fa-sign-in',
        onConfirm: () => {
          const { id, login } = this.form;
          impersonateMember({
            id,
            email:login
          });

          this.$mixpanel?.track('settings_impersonate', {
            source:'modal',
            owner_email:this.$store.state.user.email,
            member_email:login,
          });
        },
      }})
    }

    removeWorkspaceConfirmCall(id:string) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
        message: this.t('All selected items will be deleted permanently if you press OK.'),
        onConfirm: () => this.form.workspaces = this.form.workspaces.filter((workspace:any) => workspace.id !== id),
      }})
    }

    reset2FAButtonHandle() {
      if(this.form.twoFactorDisableCheck) {
        this.form.twoFactorDisableCheck = false;
      } else {
        this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
          message: this.t('The current 2FA settings will be reset for this role if you press OK. When logging in to the panel it will be required to scan the QR code again and specify the code from the app.'),
          onConfirm: () => this.form.twoFactorDisableCheck = true,
        }})
      }
    }

    handleBlockClick() {
      this.form.status = this.form.status==='blocked' ? 'active': 'blocked'
    }

    toggleAddWorkspacesMenu(){
      if(!this.isAddWorkspaceMenuOpened){
        let selected:any=[];
        this.form.workspaces.forEach((workspace:any)=>{
          selected.push(this.allPrivateWorkspacesNormalized[workspace.id])
        })
        this.addWorkspaceMenuSelected = [...selected];
        this.workspacesSearch='';
      }
      this.isAddWorkspaceMenuOpened = !this.isAddWorkspaceMenuOpened;
    }

    get addMemberMenuIsSelectedAll(){
      return this.addWorkspaceMenuSelected.length === this.allPrivateWorkspaces.length
    }

    set addMemberMenuIsSelectedAll(value: boolean) {
      if(value){
        this.addWorkspaceMenuSelected = [...this.allPrivateWorkspaces]
      } else {
        this.addWorkspaceMenuSelected = []
      }
    }

    mounted() {
      this.$on('error', (e: any) => {
        this.$store.commit('loading', false);
        this.errors = this.translateErrors(this.parseErrors(e.data.errors), e.data.message);
        this.errorsControlActive = true;
      });

      this.open(this.data.user)
    }


  }
